import * as React from 'react'

import * as styles from './defaultItemPreviewer.module.css'

const DefaultItemPreviewer = ({
  url,
  imageUrl,
  onClick,
  name,
  isSquareImage
}: {
  url: string
  name: string
  imageUrl: string
  onClick?: () => void
  isSquareImage?: boolean
}) => {
  const imgClassName = isSquareImage ? styles.img : ''
  return (
    <a href={url} onClick={onClick}>
      <img alt={name} className={imgClassName} src={imageUrl} />
    </a>
  )
}
export default DefaultItemPreviewer
